import { apiGet } from "./apiHelper";

export const fetchFreightDocument = async (culture: string): Promise<string | null> => {
    const response = await apiGet<{ url?: string | null }>(
        `/api/freight-document?culture=${culture}`
    );
    return response.data.url ?? null;
};
